import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderOptimizerOverviewRoutingModule } from './order-optimizer-overview-routing.module';
import { OrderOptimizerOverviewComponent } from './order-optimizer-overview.component';
import { FormsModule } from '@angular/forms';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { DxButtonModule, DxDataGridModule, DxDropDownButtonModule, DxLoadPanelModule, DxTextBoxModule } from 'devextreme-angular';
import { DropDownFilterModule } from 'src/app/widgets';
import { OrderDetailGridModule } from './order-detail-grid/order-detail-grid.component';
import { InfoHeaderModule } from 'src/app/widgets/info-header/info-header.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BookmarksControlsComponent } from 'src/app/widgets/bookmark-new/bookmarks-controls/bookmarks-controls.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';


@NgModule({
  declarations: [
    OrderOptimizerOverviewComponent
  ],
  imports: [
    CommonModule,
    OrderOptimizerOverviewRoutingModule, FormsModule,BookmarkModule,
    DxLoadPanelModule, DropDownFilterModule, DxLoadPanelModule,DxButtonModule,DxTextBoxModule, DxDropDownButtonModule,DxDataGridModule,OrderDetailGridModule,
    InfoHeaderModule,BookmarkNewComponent,
		BookmarksControlsComponent,
		HelpButtonComponent,
		FiltersGroupModule,
  ]
})
export class OrderOptimizerOverviewModule { }
